import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getBatch,
  importCsv,
  listBatches,
  priceHistory,
  upsertPrice,
  type ManualPriceInput,
} from "./api";

export const usePriceHistory = (securityId: string | null) =>
  useQuery({
    queryKey: ["prices", securityId],
    queryFn: () => priceHistory(securityId as string),
    enabled: !!securityId,
  });

export function useUpsertPrice(securityId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ManualPriceInput) => upsertPrice(securityId as string, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["prices", securityId] }),
  });
}

export const useImportBatches = () =>
  useQuery({ queryKey: ["import-batches"], queryFn: listBatches });

export function useImportCsv() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ csv, filename }: { csv: string; filename: string }) => importCsv(csv, filename),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["import-batches"] }),
  });
}

export const useBatch = (id: string | null) =>
  useQuery({
    queryKey: ["import-batch", id],
    queryFn: () => getBatch(id as string),
    enabled: !!id,
    refetchInterval: (q) => (q.state.data?.status === "processing" ? 1200 : false),
  });
